import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();
export const getEnvVar = (key: string) => {
  return import.meta.env[key];
};
